import React from 'react'
import { useCallback } from 'react'
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import { useJsApiLoader } from '@react-google-maps/api';
import initMap from './MyMapUtils/initMap';
import markerContent from './MyMapUtils/markerContent';
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';
import GetOverallHealthLevelInfo from './MyMapUtils/GetOverallHealthLevelInfo';

const viewType = window.SIMPL.viewType;
const googleMapsApiKey = "AIzaSyCMzvfRYe0Tfz2A-n3Z1KXAFhPQwNbuDo0";

export default function MyMap(props) {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: googleMapsApiKey
    })
    const onLoad = useCallback((map) => {
        initMap(map,props.ControlPosition,props.mapServerType);
        map.setMapTypeId(props.mapType);
        props.onInitMap(map);
    }, [])

    const polylineOptions = function(isActive,item) {
        var color = "";
        var zIndex = 1;
        var type = GetfacilityTypeData(item.type,"type");
        if(type === "pavement10" || type === "pavement100"){
            color = GetOverallHealthLevelInfo(item.overallHealthLevel,"color");
            zIndex = GetOverallHealthLevelInfo(item.overallHealthLevel,"zIndex");
        }else{
            color = '#FF0000';  //赤固定
        }

        //JICE環境の場合のみ、矢印をカスタマイズ
        if(viewType === "jice"){
            return {
                icons: isLoaded && [
                    {
                        icon: {
                            path : "M-2,2 L0,0 L2,2",
                            strokeWeight : 3
                        },
                        offset: '100%'
                    }
                ],
                clickable: false,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 1.0,
                strokeWeight: isActive ? 6:3,
                zIndex:zIndex
            }
        }else{
            return {
                icons: isLoaded && [
                    {
                        icon: {
                            path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW
                        },
                        offset: '100%'
                    }
                ],
                clickable: false,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 1.0,
                strokeWeight: isActive ? 6:3
            }
        }
    }
    const clickablePolylineOptions = {
        clickable: true,
        geodesic: true,
        strokeOpacity: 0.0,
        strokeWeight: 50
    }
    
    function getPolylineSet(item, isActive) {
        return [
            <Polyline 
                key={item.id + '-line'}
                path={item.coordinates}
                options={polylineOptions(isActive,item)}
            />,
            <Polyline 
                key={item.id + '-clickable'}
                path={item.coordinates}
                options={clickablePolylineOptions}
                onClick={ function (event) { toggleInfoWindow(this, item, props.items, event) }}
            />
        ]
    }
    
    return isLoaded ? (
        <GoogleMap mapContainerStyle={props.containerStyle}
                            zoom={15}
                            onLoad={onLoad}
                            onIdle={props.onIdle}
                            onClick={function(event){props.isClick && props.onClickedMap(event)}}
                            onTilesLoaded={function(event){props.onTilesLoaded(event)}}
                            id='googleMap'>
            {props.items && props.items.map(item =>
                (GetfacilityTypeData(item.type,"mapMarkerType") === 'line') ?
                    getPolylineSet(item, (props.activeItem && item.id === props.activeItem.id))
                :
                <Marker
                    id={item.id}
                    key={item.id}
                    position={{lat:item.startLat, lng:item.startLng}}
                    icon={item.type === "photo" ?{ 
                        path: "M0 0 L-2 1.5 L0 -3 L2 1.5 L0 0 Z",
                        scale:6,
                        rotation:parseInt(item.angle !== undefined ? item.angle:0),
                        fillColor: props.selectedItem?.id === item.id ?'#3952dd' :'#DD4B39',
                        
                        fillOpacity: 0.5,
                        strokeColor: props.selectedItem?.id === item.id ? '#405490':'#904040',
                        strokeWeight: 2,
                        strokeOpacity: 0.9
                    }
                    :{
                        url: GetfacilityTypeData(item.type,"icon",true)
                        // scaledSize: (props.activeItem && item.id === props.activeItem.id) ? new window.google.maps.Size(40, 40): new window.google.maps.Size(30, 30)
                    }}
                    zIndex={props.selectedItem?.id === item.id ? 99 : 1}
                    anchor={new window.google.maps.Point(12, 12)}
                    draggable={props.isDraggable && props.selectedItem?.id === item.id}
                    autoPan={props.isDraggable && props.selectedItem?.id === item.id}
                    onDragEnd={function(event){props.isDraggable && props.onDragendMarker(this,event)}}
                    title={item.title}
                    animation={(props.activeItem && item.id === props.activeItem.id) && item.startLnt !== 0 && item.startLng !== 0 ? window.google.maps.Animation.BOUNCE : null}
                    onClick={ function (event) { props.showInfoWindow ? toggleInfoWindow(this, item, props.items, event,props.onTagClick,props.onChangeActiveItem) : props.onChangeSelectedRowAndEditClear(item,null,false,true) }}
                />
            )}
        </GoogleMap>
    ) : <></>
}

function toggleInfoWindow(marker, item, items, event,onTagClick,onChangeActiveItem) {
    //ActiveItemの変更
    // onChangeActiveItem(item);

    if (marker.window == null) {
        marker.window = new window.google.maps.InfoWindow({
            content: markerContent(item, sameLatLngItems(item, items)),
            position: event.latLng
             // polyline の場合を考慮してevent.latLngを利用
        });
        marker.window.open({
            map:marker.getMap(), 
            anchor:marker, 
            shouldFocus:false
        });
        marker.window.addListener("closeclick", function () {
            marker.window = null;
        });
        marker.window.addListener("domready", function () {
            var trigger = document.querySelectorAll('.tag');
            trigger.forEach(function(target) {
                target.addEventListener('click', (val) => {
                    onTagClick(val.target.value);
                });
            });

            var trigger2 = document.querySelectorAll('.title-btn');
            trigger2.forEach(function(target) {
                target.addEventListener('click', (val) => {
                    onChangeActiveItem(val.target.name);
                });
            });
        });
    }
    else {
        marker.window.close();
        marker.window = null;
    }
}
function sameLatLngItems(target, items){
    return items.filter(item => item.startLat === target.startLat && item.startLng === target.startLng);
}
